import { AGGREGATE_NAMES, WABA_RESOLVERS } from 'cpool-constants';
import type { SchemaWabaResolver_GetWhatsAppTemplatesItem } from 'cpool-tables/backend-resolvers';
import { schemaWabaResolver_GetWhatsAppTemplates } from 'cpool-tables/backend-resolvers';

import { useAggregateQuery } from '~/queryUtils/useQuery';

export type WhatsAppTemplate = SchemaWabaResolver_GetWhatsAppTemplatesItem;

export const useWhatsAppTemplates = () => {
    return useAggregateQuery({
        acl: {},
        aggregateName: AGGREGATE_NAMES.WABA,
        resolverName: WABA_RESOLVERS.getWhatsAppTemplates,
        schema: schemaWabaResolver_GetWhatsAppTemplates,
        searchParams: {},
    });
};
